<template>
   <div class="aaaa">
    <button class="butn" @click="a()">用户A</button><br>
    <button class="butn" @click="b()">用户B</button><br>
    <button class="butn" @click="c()">用户C</button>
  </div>
</template>
<script>
import user_model from '../tool/user_model'
import * as hs_api from '../../api/api'
import http from '../../utils/http'
export default {
  data () {
    return {}
  },
  components: {},
  props: {},
  created () { },
  mounted () { },
  methods: {
    a () {
      //zswd9999
      //add_user('zswd9999');
      // window.localStorage.setItem('openid', 999999)
      window.sessionStorage.removeItem("user_model");  //#指定键删除
      this.$api.getAPI("mutual/attribute/?appid=202108&type_id=4001&openid=zswd9999", {}).then(res => {
        const user_model = res.data.data.data[0].models[0];
        console.log(user_model);
        const rowObj = JSON.stringify(user_model)
        window.sessionStorage.setItem('user_model', rowObj);
        //this.$router.push('/index')
      })
    },
    b () {
      window.sessionStorage.removeItem("user_model");  //#指定键删除
      this.$api.getAPI("mutual/attribute/?appid=202108&type_id=4001&openid=13857655846", {}).then(res => {
        const user_model = res.data.data.data[0].models[0];
        console.log(user_model);
        const rowObj = JSON.stringify(user_model)
        window.sessionStorage.setItem('user_model', rowObj);
        this.$router.push('/index')
      })
    },
    c () {
      //let data = {openid:"12322222222222222224",username:"yyyy"};

      // let data = new FormData()
      // data.append('key_id', 1)
      // data.append('title', "1")
      // data.append('username', "222222")
      // data.append('openid', "222222222222")
      // data.append('avatar_url', "2222")

      //hs_api.getListAPI(data)
      //       var a= http.post(`https://yjz.hsnms.com/app/mutual/attribute/?appid=202108&type_id=4001`, {
      //   openid: 'Fred',        // 参数 firstName
      //   username: 'Flintstone'    // 参数 lastName
      // })
      //        a.then(res => {
      //          console.log(res);
      //          });




      // let data = new FormData()
      // data.append('key_id', 1)
      // data.append('title', 1)
      // data.append('username', 1)
      // data.append('telephone', 1)
      // data.append('address', 1)
      // data.append('range', 1)
      // data.append('explain', 1)
      // data.append('openid', 11111336699)
      // data.append('avatar_url', 1)
      // this.$api.postAPI(`mutual/attribute/?appid=202108&type_id=4001`, data).then(res => {
      //   console.log(res);
      // });

      // hs_api.getAPI("mutual/assistance/3?appid=202108&type_id=3001",{}).then(res => {
      //    console.log(res.data);
      //          //数据处理
      //        }).catch(err => console.log(err))


      //var db=this.$common.name
      //console.log(db);
      //window.localStorage.setItem('openid', 2354414)
      //this.$router.push('/home')
    },
  }
}
</script>
<style>
.aaaa {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -60%);
}
.butn {
  background: #01b2c2;
  color: #fff;
  border: none;
  width: 160px;
  padding: 10px 5px;
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/ceshi.vue